import { makeVar, useReactiveVar } from '@apollo/client';
import { Position, Dimension } from 'types';

type SelectedArea = (Position & Dimension) | undefined;

interface SelectedAreaOperations {
  setSelectedArea: (selectedArea: SelectedArea) => void;
  clearSelectedArea: () => void;
}

const selectedAreaVar = makeVar<SelectedArea>(undefined);

const selectedAreaOperations = {
  setSelectedArea,
  clearSelectedArea,
};

function setSelectedArea(selectedArea: SelectedArea): void {
  selectedAreaVar(selectedArea);
}

function clearSelectedArea() {
  // We wanna delay removing the area to give opportunity to Control component icons to fire onClick handlers
  setTimeout(() => selectedAreaVar(undefined), 200);
}

export function useSelectedArea(): [SelectedArea, SelectedAreaOperations] {
  const selectedArea = useReactiveVar(selectedAreaVar);

  return [selectedArea, selectedAreaOperations];
}

export function useSelectedAreaOperations(): SelectedAreaOperations {
  return selectedAreaOperations;
}
